import { routerHelpers } from '@approvalmax/utils';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { showReceiptBankAuthModule } from '../actions';
import { RB_AUTH_PAGE_ID } from '../config';

const useReceiptBankAuthPageData = () => {
    const dispatch = useDispatch();
    const search = useLocation().search;
    const callBackUrl = routerHelpers.getParamAsString(search, 'callback_url', '');

    useEffect(() => {
        dispatch(
            showReceiptBankAuthModule({ callbackUrl: decodeURIComponent(callBackUrl), innerPageId: RB_AUTH_PAGE_ID })
        );
    }, [callBackUrl, dispatch]);
};

export default useReceiptBankAuthPageData;
